import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { AxiosResponseAndError } from "@/api/types/axiosResponseType";
import { UserResponseType } from "../query/useCurrentUserQuery";
import ApiRequest from "../ApiRequest";

function useReadAllNotificationMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<UserResponseType>["response"],
    AxiosResponseAndError<UserResponseType>["error"]
  >({
    mutationFn: () =>
      ApiRequest.put<UserResponseType>(requestURLs.notification),
  });

  return mutation;
}
export default useReadAllNotificationMutation;